import * as React from "react";
const SvgAssessmentDial = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 200,
	height: 164,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M8.002 101.595c.266 15.627 4.429 30.305 11.557 43.105l-6.93 4.001C4.819 134.724.268 118.68 0 101.595h8.002Z",
	fill: "var(--icon-critical-red)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M19.56 55.29C12.43 68.09 8.268 82.769 8.002 98.396H0c.268-17.084 4.82-33.129 12.629-47.106l6.93 4.002Z",
	fill: "var(--icon-critical-red)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M52.523 21.165a92.475 92.475 0 0 0-31.358 31.357l-6.93-4.001A100.516 100.516 0 0 1 48.52 14.234l4.002 6.931Z",
	fill: "var(--action-critical-default)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M98.395 8.002C82.768 8.268 68.09 12.43 55.29 19.559l-4.002-6.93C65.266 4.819 81.311.268 98.395 0v8.002Z",
	fill: "var(--action-critical-default)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M144.879 19.66c-12.841-7.19-27.583-11.39-43.283-11.658V0c17.157.27 33.265 4.859 47.284 12.729l-4.001 6.93Z",
	fill: "var(--icon-success-lime)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M178.926 52.69a92.475 92.475 0 0 0-31.282-31.419l4.001-6.93a100.513 100.513 0 0 1 34.212 34.347l-6.931 4.001Z",
	fill: "var(--icon-success-lime)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M191.989 98.395c-.266-15.557-4.393-30.175-11.464-42.934l6.931-4.001c7.751 13.937 12.267 29.92 12.534 46.935h-8.001Z",
	fill: "var(--icon-success-grass)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M180.525 144.529c7.071-12.759 11.198-27.376 11.464-42.934h8.001c-.267 17.015-4.783 32.999-12.534 46.936l-6.931-4.002Z",
	fill: "var(--icon-success-grass)"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M22.96 142.583c-6.991-12.62-10.972-27.139-10.972-42.588 0-48.605 39.402-88.007 88.007-88.007 48.605 0 88.007 39.402 88.007 88.007 0 15.449-3.981 29.969-10.972 42.588l-20.738-12.111c4.916-9.061 7.708-19.443 7.708-30.477 0-35.349-28.656-64.005-64.005-64.005-35.35 0-64.005 28.656-64.005 64.005 0 11.034 2.792 21.416 7.708 30.478l-20.737 12.11Z",
	fill: "var(--action-primary-soft-hover)"
}), /* @__PURE__ */ React.createElement("g", { filter: "url(#a)" }, /* @__PURE__ */ React.createElement("circle", {
	cx: 99.99,
	cy: 100,
	fill: "var(--surface-default)",
	r: 60
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", {
	id: "a",
	x: 35.99,
	y: 36,
	width: 128,
	height: 128,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", null), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 0 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }), /* @__PURE__ */ React.createElement("feBlend", {
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_1921_10692"
}), /* @__PURE__ */ React.createElement("feBlend", {
	in: "SourceGraphic",
	in2: "effect1_dropShadow_1921_10692",
	result: "shape"
}))));
export default SvgAssessmentDial;
